module.exports = __webpack_public_path__ + "img/style_select_icon.adab3716.svg";